import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class StateModel extends BaseModel {

    constructor() {
        super({
                name: "state",
                tableName: 'state',
                label: "Tỉnh/TP",
                display_key: 'name',
                default_order: { key: 'name', direction: 'asc' }
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: "id",
                    display: false
                },
                name: { 
                    name: 'name',
                    type: "String",
                    label: 'Tên tỉnh/tp',
                    sortable: false,
                    width: 12,
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                },
                updated_at: {
                    name: 'updated_at',
                    type: "Datetime",
                    label: 'Ngày cập nhật',
                    filter: {
                        type: "DateRange", match: "contrains",
                    },
                },

            },
            )
    }

}